import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import TextField from 'lib/ui/TextField'
import {Label} from 'lib/ui/typography'
import {useNiftyFiftyTemplate} from 'Event/template/NiftyFifty'
import {useAttendeeVariables} from 'Event'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'

export default function Settings(props: {
  control: UseFormMethods['control']
  register: UseFormMethods['register']
}) {
  const {control, register} = props
  const template = useNiftyFiftyTemplate()
  const {welcomeText, homeMenuTitle} = template

  const v = useAttendeeVariables()
  return (
    <>
      <Label>Welcome Text</Label>
      <HTMLEditorContainer>
        <Controller
          name="welcomeText"
          control={control}
          defaultValue={v(welcomeText)}
          render={({value, onChange}) => (
            <HTMLEditor
              data={value || ''}
              onChange={onChange}
              aria-label="welcome text"
            />
          )}
        />
      </HTMLEditorContainer>
      <Label>Menu Title</Label>
      <TextField
        name="homeMenuTitle"
        aria-label="home menu title"
        fullWidth
        defaultValue={v(homeMenuTitle)}
        inputProps={{
          ref: register,
        }}
      />
    </>
  )
}
